module.exports = __webpack_public_path__ + "img/light.b36090d2.webp";